import s from './ComponentSpinner.scss'
import ReactLoading from 'react-loading'

const ComponentSpinner = () => (
  <div className={s.loadingDiv}>
    <ReactLoading type="spinningBubbles" />
  </div>
)

export default ComponentSpinner
